/**
 * Removes the given property from source object and returns new object. This function will not mutate the source object.
 * @param {Object} obj The source object
 * @param  {...(string|string[])} paths The property paths to omit.
 * @returns {Object} Returns new object.
 */

export default function omit(obj, ...paths) {
	//converting multiple arrays into single array
	let removeElement =
		paths.length > 0 &&
		paths.reduce((result, element) => {
			Array.isArray(element) ? result.push(...element) : result.push(element)
			return result
		}, [])
	let newObj = Object.assign({}, obj)
	if (removeElement.length > 0) {
		// if 'removeElement' is not available returns new source object
		removeElement.forEach(element => {
			delete newObj[element] // deleting matched property from new source object
		})
	}

	return newObj
}
